<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="540"
      @keydown.esc="dialog = false"
    >
      <v-card
        class="pa-8 text-center"
        :class="{
          'winner-card': isWinner,
          'loser-card': !isWinner,
        }"
        rounded="xl"
        elevation="24"
      >
        <div
          v-if="
            rewardValue &&
            rewardValue.trim() !== '' &&
            rewardValue !== 'پوچ' &&
            prizeName !== 'پوچ'
          "
          class="fireworks-bg"
        ></div>

        <v-icon
          v-if="
            rewardValue &&
            rewardValue.trim() !== '' &&
            rewardValue !== 'پوچ' &&
            prizeName !== 'پوچ'
          "
          size="150"
          class="trophy-shake mb-6"
        >
          mdi-trophy
        </v-icon>

        <v-icon v-else size="150" color="#F35240AB" class="mb-6">
          mdi-emoticon-sad-outline
        </v-icon>
        <h1 class="text-h3 font-weight-black mb-3 qr-italic winner-title">
          {{ winnerMessage }}
        </h1>

        <p class="text-h5 ma-0 mb-8 white--text text--darken-1">
          {{ winnerSubtitle }}
        </p>

        <div class="prize-box pa-7 mb-7">
          <p class="text-overline mb-3 grey--text text--lighten-1">جایزه شما</p>

          <p
            class="text-h4 font-weight-bold qr-italic mb-4"
            style="font-size: 2.2rem !important"
          >
            {{ prizeName || "جایزه ویژه" }}
          </p>

          <div v-if="rewardValue" class="mt-6">
            <p class="text-body-1 mb-3 grey--text">متن جایزه :</p>
            <div class="reward-code pa-4 rounded-xl">
              <strong class="text-h5 font-weight-bold qr-italic">
                {{ rewardValue }}
              </strong>
            </div>
          </div>
        </div>

        <!-- دکمه‌ها -->
        <div class="d-flex flex-column ga-3">
          <v-btn
            v-if="
              rewardValue && rewardValue.trim() !== '' && rewardValue !== 'پوچ'
            "
            x-large
            rounded
            :color="prizeColor"
            dark
            class="px-12 shadow-lg mb-3 luxury-btn"
            @click="copyAndToast"
          >
            <v-icon left size="30">mdi-content-copy</v-icon>
            کپی کد جایزه
          </v-btn>

          <v-btn text large color="grey lighten-1" @click="dialog = false">
            بستن
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- اسنک‌بار موفقیت -->
    <v-snackbar
      v-model="snackbar"
      timeout="3000"
      color="success"
      rounded="pill"
      top
      class="font-weight-bold"
    >
      <v-icon left>mdi-check-circle</v-icon>
      کد با موفقیت کپی شد!
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "WinnerCelebrationPopup",

  props: {
    value: { type: Boolean, default: false },
    prizeName: { type: String, default: "جایزه ویژه" },
    rewardValue: { type: String, default: "" },
  },

  data() {
    return {
      dialog: this.value,
      snackbar: false,
    };
  },

  computed: {
    isWinner() {
      return (
        this.rewardValue &&
        this.rewardValue.trim() !== "" &&
        this.rewardValue !== "پوچ" &&
        this.prizeName !== "پوچ"
      );
    },
    winnerMessage() {
      if (
        !this.rewardValue ||
        this.rewardValue.trim() === "" ||
        this.rewardValue === "پوچ" ||
        this.prizeName === "پوچ"
      ) {
        return "در تلاش های بعدی برنده شوید!";
      }
      return "تبریک! شما برنده شدید!";
    },

    winnerSubtitle() {
      if (
        !this.rewardValue ||
        this.rewardValue.trim() === "" ||
        this.rewardValue === "پوچ" ||
        this.prizeName !== "پوچ"
      ) {
        return "متأسفانه جایزه‌ای برای این بخش در نظر گرفته نشده بود";
      }
      return "🎉یه جایزه فوق‌العاده در انتظارته 🎉";
    },

    prizeColor() {
      const parent = this.$parent;
      if (parent && parent.prizes && parent.serverPrizeId) {
        const wonPrize = parent.prizes.find(
          (p) => p.prize_id === parent.serverPrizeId
        );
        return wonPrize?.color || "#c9a96e";
      }
      return "#c9a96e";
    },
  },
  watch: {
    value(val) {
      this.dialog = val;
      if (val) {
        this.playWinSound();
      }
    },
    dialog(val) {
      this.$emit("input", val);
    },
  },

  methods: {
    playWinSound() {
      const audio = new Audio(
        "https://assets.mixkit.co/sfx/preview/mixkit-achievement-bell-600.mp3"
      );
      audio.volume = 0.8;
      audio.play().catch(() => {});
    },

    copyAndToast() {
      const el = document.createElement("textarea");
      el.value = this.rewardValue;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.snackbar = true;
    },
  },
};
</script>

<style scoped>
.qr-italic {
  font-family: "Playfair Display", "Georgia", serif !important;
  font-style: italic !important;
  font-weight: 600 !important;
  letter-spacing: 1.2px !important;
  background: linear-gradient(120deg, #c9a96e 0%, #f4e4bc 50%, #c9a96e 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
  display: inline-block;
  animation: luxuryGoldFlow 4s ease-in-out infinite;
}

@keyframes luxuryGoldFlow {
  0%,
  100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

.winner-card {
  position: relative;
  overflow: hidden;
  background: linear-gradient(
    135deg,
    #0f0f1a 0%,
    #1a1a2e 50%,
    #16213e 100%
  ) !important;
  border: 4px solid #c9a96e !important;
  border-radius: 32px !important;
  direction: rtl;
}
.loser-card {
  position: relative;
  overflow: hidden;
  background: linear-gradient(
    135deg,
    #1a0f0f 0%,
    #2e1a1a 50%,
    #3e1616 100%
  ) !important;
  border: 4px solid #c9a96e !important;
  border-radius: 32px !important;
  direction: rtl;
}

.fireworks-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("./giphy.gif") center/cover no-repeat;
  opacity: 0.2;
  pointer-events: none;
  border-radius: 28px;
}

.trophy-shake {
  color: #c9a96e !important;
  animation: trophyShake 1.5s ease-in-out infinite;
  filter: drop-shadow(0 0 40px #c9a96e) drop-shadow(0 0 60px #f4e4bc);
}

@keyframes trophyShake {
  0%,
  100% {
    transform: translateY(0) rotate(-2deg) scale(1);
  }
  25% {
    transform: translateY(-1px) rotate(1deg) scale(1.005);
  }
  50% {
    transform: translateY(-3px) rotate(-1deg) scale(1.01);
  }
  75% {
    transform: translateY(-2px) rotate(2deg) scale(1.005);
  }
}

.prize-box {
  background: linear-gradient(
    135deg,
    rgba(201, 169, 110, 0.15),
    rgba(244, 228, 188, 0.08),
    rgba(201, 169, 110, 0.12)
  );
  border: 3px dashed #c9a96e;
  border-radius: 32px;
  backdrop-filter: blur(20px);
  box-shadow: inset 0 0 40px rgba(201, 169, 110, 0.15);
}

.reward-code {
  background: linear-gradient(
    135deg,
    rgba(201, 169, 110, 0.25),
    rgba(244, 228, 188, 0.15)
  );
  border: 2px solid #c9a96e;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(201, 169, 110, 0.3);
}

.luxury-btn {
  background: linear-gradient(45deg, #c9a96e, #f4e4bc) !important;
  color: #1a1a2e !important;
  font-weight: 700 !important;
  letter-spacing: 1px;
  box-shadow: 0 12px 35px rgba(201, 169, 110, 0.4) !important;
}

.shadow-lg {
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5), 0 0 40px rgba(201, 169, 110, 0.3) !important;
}

.ga-3 > * + * {
  margin-top: 1.2rem;
}

@media (max-width: 600px) {
  .winner-card {
    margin: 15px !important;
  }
  .trophy-shake {
    font-size: 110px !important;
  }
}
</style>
